export default class DateTimeFormats {
  static TIME = "HH:mm";

  static DATETIME = "DD.MM.YYYY HH:mm";

  static DATETIME_TEXT = "MMM DD, YYYY HH:mm";

  static DATE = "DD.MM.YYYY";

  static DATE_TEXT = "MMM DD, YYYY";

  static DATE_TEXT_EXT = "MMMM DD, YYYY";

  static MONTH = "MM";

  static MONTH_TEXT = "MMM";

  static SHORT_DATE = "DD.MM";

  static SHORT_DATE_TEXT = "MMM DD";

  static YEAR_AND_MONTH = "YYYY.MM";

  static MONTH_AND_YEAR = "MM.YYYY";

  static MONTH_AND_YEAR_TEXT = "MMM YYYY";

  static MONTH_AND_YEAR_TEXT_EXT = "MMMM YYYY";

  static API_DATE = "YYYY-MM-DD";

  static API_MONTH_DATE = "YYYY-MM";

  static NO_TIMEZONE_FORMAT = "YYYY-MM-DDTHH:mm:ss";
}
